// extracted by mini-css-extract-plugin
module.exports = {"container":"ReportsSection_container__30nQO","ai-addendum-and-resources":"ReportsSection_ai-addendum-and-resources__1Z9Lj"};